
import { useState, useEffect, useRef } from 'react';

const stats = [
  { number: 14, suffix: '+', label: 'Anos no mercado', icon: 'ri-time-line' },
  { number: 5000, suffix: '+', label: 'empresas aumentaram suas vendas com a GUEPARDO', icon: 'ri-rocket-line' },
  { number: 12, suffix: '', label: 'países com presença ativa em projetos e consultorias internacionais', icon: 'ri-global-line' },
  { number: 700, suffix: 'M', label: 'de pessoas impactadas por anúncios criados por nós', icon: 'ri-eye-line' }
];

export function Stats() {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState(stats.map(() => 0));
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;

    stats.forEach((stat, index) => {
      let currentStep = 0;
      const increment = stat.number / steps;

      const timer = setInterval(() => {
        currentStep++;
        setCounts((prev) => {
          const newCounts = [...prev];
          newCounts[index] = Math.min(Math.round(increment * currentStep), stat.number);
          return newCounts;
        });

        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, stepDuration);
    });
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="py-24 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-200 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-100 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 rounded-full bg-gradient-to-br from-amber-200 to-amber-100 group-hover:scale-110 transition-transform duration-300">
                <i className={`${stat.icon} text-4xl text-black`}></i>
              </div>
              <div className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-100 mb-4">
                {counts[index]}{stat.suffix}
              </div>
              <p className="text-white text-lg font-medium leading-relaxed max-w-xs mx-auto">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
